module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/114.7d0ce7c0.png";